{
  "id": "default",
  "name": "Default",
  "description": "Default theme with original colors",
  "colors": {
    "light": {
      "primary": "#1976d2",
      "secondary": "#ddeaf8",
      "positive": "#21ba45",
      "negative": "#f44336",
      "warning": "#f59e0b",
      "important": "#ff8f00",
      "light": "#fafafa",
      "dark": "#09090b",
      "surface": "#eeeeee",
      "darksurface": "#18181b",
      "white": "#ffffff"
    },
    "dark": {
      "primary": "#4b6d9e",
      "secondary": "#394657",
      "positive": "#4dce73",
      "negative": "#f44336",
      "warning": "#f59e0b",
      "important": "#ff8f00",
      "light": "#fafafa",
      "dark": "#09090b",
      "surface": "#eeeeee",
      "darksurface": "#18181b",
      "white": "#ffffff"
    }
  }
}
